// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4c8142cc] .g-input .body .g-field-wrapper .content{border-radius:4px;border:1px solid #dee0eb;height:40px}[data-v-4c8142cc] .g-input .body .g-field-wrapper .content input{font-size:1rem!important}", ""]);
// Exports
module.exports = exports;
